import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import Msg = ww.Msg;

export const lendingAccounts$ = new BehaviorSubject<LendingAccount[]>([]);

wwData$
  .pipe(
    filter<Msg<{accounts: LendingAccount[]}>>((o) => o.type === 'lending-accounts'),
    map<Msg<{accounts: LendingAccount[]}>, LendingAccount[]>((o) => o.data.accounts)
  )
  .subscribe((accounts) => lendingAccounts$.next(accounts));
